import type { SxProps, Theme } from '../../../../themes/themes';

export const getStyles = (theme: Theme): { [key: string]: SxProps } => {
  return {
    content: {
      height: '100%',
      marginTop: '126px',
      overflow: 'hidden',
    },
    header: {
      position: 'fixed',
      left: 0,
      top: 0,
      zIndex: theme.zIndex.drawer + 10,
      width: '100%',
      backgroundColor: theme.palette.primary.contrastText,
    },
    logoActive: {
      color: theme.palette.primary.main,
    },
    panels: {
      position: 'relative',
      left: 0,
      top: 0,
      height: '100%',
    },
    panel: {
      position: 'absolute',
      left: 0,
      top: 0,
      background: theme.palette.background.default,
      height: '100%',
      width: '100%',
      overflow: 'hidden',
      overflowY: 'auto',
    },
    customPanel: {
      position: 'absolute',
      left: 0,
      top: 0,
      height: '100%',
      width: '100%',
      overflow: 'hidden',
      overflowY: 'auto',
      background: theme.palette.background.default,
      zIndex: 20,
    },
    upper: {
      outline: 0,
      textTransform: 'uppercase',
    },
    isMobile: {
      display: 'block',
      [theme.breakpoints.up('md')]: {
        display: 'none',
      },
    },
    hidden: {
      visibility: 'hidden',
    },
  };
};
